import { TrackingEvent } from 'client/tracking/event';
import { TrackingConstant } from 'client/tracking/constant';

const map = {
  range_and_battery: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    'display_range-and-battery_details'
  ),

  charging_info: TrackingEvent.actionCompleted(TrackingConstant.ACTION_VIEW_CONTENT, 'display_charging_details'),

  tax_credit_and_rebates: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    'display_incentive_details'
  ),

  display_incentive_program_details: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.DISPLAY_INCENTIVE_PROGRAM_DETAILS
  ),
};

export const EvInsights = {
  ...map,
};
